import { useState, useEffect } from 'react';
import { Bell } from 'lucide-react';

export function PushNotificationModal() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Only show if not asked before and notifications are supported
    const hasAsked = localStorage.getItem('push_notification_asked');
    if (!hasAsked && 'Notification' in window) {
      if (Notification.permission === 'default') {
        const timer = setTimeout(() => setShow(true), 10000); // show after 10 seconds
        return () => clearTimeout(timer);
      }
    }
  }, []);

  const handleSubscribe = () => {
    if ('Notification' in window) {
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          console.log('Notification permission granted.');
          // Here we would normally subscribe to Firebase Cloud Messaging (FCM)
          // and send the registration token to our server
        }
        localStorage.setItem('push_notification_asked', 'true');
        setShow(false);
      });
    }
  };

  const handleDismiss = () => {
    localStorage.setItem('push_notification_asked', 'true');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 animate-in slide-in-from-bottom duration-500">
       <div className="max-w-md mx-auto bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-5 border border-gray-100 dark:border-gray-700 relative overflow-hidden">
         <div className="absolute top-0 left-0 w-full h-1 bg-[#D32F2F]"></div>
         <div className="flex gap-4">
           <div className="flex-shrink-0">
             <div className="w-12 h-12 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center text-[#D32F2F]">
               <Bell className="w-6 h-6" />
             </div>
           </div>
           <div>
             <h3 className="font-bold text-[#111111] dark:text-white font-bengali text-lg">সবার আগে খবর পান</h3>
             <p className="text-gray-500 dark:text-gray-400 font-bengali text-sm mt-1 mb-3">সাম্প্রতিক গুরুত্বপূর্ণ খবরের নোটিফিকেশন পেতে অনুমতি দিন।</p>
             <div className="flex gap-3">
                <button 
                  onClick={handleDismiss}
                  className="px-4 py-2 text-sm font-bold font-bengali text-gray-700 bg-gray-100 dark:bg-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
                >
                  পরে
                </button>
                <button 
                  onClick={handleSubscribe}
                  className="px-4 py-2 text-sm font-bold font-bengali text-white bg-[#D32F2F] hover:bg-red-700 rounded-lg transition-colors"
                >
                  চালু করুন
                </button>
             </div>
           </div>
         </div>
       </div>
    </div>
  );
}
